/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuditLogItem } from '../../models/audit-log-item';

export interface ListAuditLog$Params {

/**
 * Filter items by USER (who, author of item), TARGER (to whom, user/profile/activity to which is item related) or by OPERATION (what, type of action that happens)
 */
  findBy: 'USER' | 'TARGET' | 'OPERATION';

/**
 * This field is user for filtering when findBy parameter is set to USER or TARGET
 */
  findId?: string;

/**
 * This field is user for filtering when findBy parameter is set to OPERATION
 */
  operation?: 'PROFILE_CREATE' | 'ACTIVITY_CREATE' | 'ESG_UPDATE';

/**
 * Parameter for pagination - timestamp of last item.
 */
  ts?: number;

/**
 * Parameter for pagination - size of page. Default is 10.
 */
  pageSize?: number;
}

export function listAuditLog(http: HttpClient, rootUrl: string, params: ListAuditLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuditLogItem>>> {
  const rb = new RequestBuilder(rootUrl, listAuditLog.PATH, 'get');
  if (params) {
    rb.path('findBy', params.findBy, {});
    rb.query('findId', params.findId, {});
    rb.query('operation', params.operation, {});
    rb.query('ts', params.ts, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuditLogItem>>;
    })
  );
}

listAuditLog.PATH = '/audit-log/{findBy}';
